import {h, Fragment} from "preact"
import { useSizeOptions } from "@nosto/preact"
import { defaultConfig, sizes } from "../config"
import Pagination from "./Pagination"

export default function BottomToolbar() {
    const { from, to, total } = useSizeOptions(sizes, defaultConfig.serpSize)

    return (
        <div className="ns-bottom-toolbar">
            <div className="body-2 pt-[30px] border-t border-gray-400">
                <Pagination />
                <div className="text-center pb-5">
                    Showing {(from === 0) ? 1 : from} - {total < to ? total : to} of {total}
                </div>
            </div>
        </div>
    )
}